/* eslint-disable no-useless-computed-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint func-names: ["error", "never"] */

import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import createPersistedState from 'vuex-persistedstate';

import axios from 'axios';
import pathify from 'vuex-pathify';

import database from './orm/database';

import * as getters from './getters';
import { state, mutations, actions } from './mutations';

/* FETCHER MODULE IMPORTS */
import fetcherAdmin from './modules/fetcher/admin/Admin';
import fetcherAdminLog from './modules/fetcher/admin/Log';
import fetcherAdminSchemas from './modules/fetcher/admin/Schemas';
import fetcherAdminChannel from './modules/fetcher/admin/models/Channel';
import fetcherAdminCommonString from './modules/fetcher/admin/models/CommonString';
import fetcherAdminFeed from './modules/fetcher/admin/models/Feed';
import fetcherAdminFeedRule from './modules/fetcher/admin/models/FeedRule';
import fetcherAdminJob from './modules/fetcher/admin/models/Job';
import fetcherAdminJobItem from './modules/fetcher/admin/models/JobItem';
import fetcherAdminList from './modules/fetcher/admin/models/List';
import fetcherAdminListItem from './modules/fetcher/admin/models/ListItem';
import fetcherAdminNetwork from './modules/fetcher/admin/models/Network';
import fetcherAdminPost from './modules/fetcher/admin/models/Post';
import fetcherAdminProfile from './modules/fetcher/admin/models/Profile';
import fetcherAdminTag from './modules/fetcher/admin/models/Tag';
import fetcherPost from './modules/fetcher/models/Post';
import fetcherTag from './modules/fetcher/models/Tag';

/* SPAWNER MODULE IMPORTS */
import spawnerAdmin from './modules/spawner/admin/Admin';
import spawnerAdminSchemas from './modules/spawner/admin/Schemas';

/* CRAWLER MODULE IMPORTS */
/* MONITOR MODULE IMPORTS */

import schemas from './modules/Schemas';
import layout from './modules/Layout';
import debug from './modules/Debug';
import site from './modules/Site';
import filter from './modules/Filter';
import keys from './modules/Keys';
import meta from './modules/Meta';
import lang from './modules/Lang';

Vue.use(Vuex);

// const axiosOrm = axios.create();

// function scheduleRequests(axiosInstance, intervalMs) {
//   let lastInvocationTime;

//   const scheduler = (config) => {
//     const now = Date.now();
//     if (lastInvocationTime) {
//       lastInvocationTime += intervalMs;
//       const waitPeriodForThisRequest = lastInvocationTime - now;
//       if (waitPeriodForThisRequest > 0) {
//         return new Promise((resolve) => {
//           setTimeout(
//             () => resolve(config),
//             waitPeriodForThisRequest,
//           );
//         });
//       }
//     }

//     lastInvocationTime = now;
//     return config;
//   };

//   axiosInstance.interceptors.request.use(scheduler);
// }

// scheduleRequests(axiosOrm, 5000);

const AxiosRequestConfig = {
  // axios: axiosOrm,
  baseURL: Vue.prototype.$api,
  url: '/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  access_token() {
    if (Vue.auth.check()) {
      return Vue.auth.token();
    }
    return '';
  },
};

VuexORM.use(VuexORMAxios, {
  database,
  http: AxiosRequestConfig,
});

// import * as actions from './actions';
// import * as mutations from './mutations';

const store = new Vuex.Store({
  plugins: [
    pathify.plugin,
    VuexORM.install(database),
    createPersistedState({
      paths: [
        /* FETCHER PERSISTEDCACHE ADMIN ORM */
        // 'entities.feed.data',
        // 'entities.feedRule.data',
        // 'entities.job.data',
        // 'entities.list.data',
        // 'entities.network.data',
        // 'entities.profile.data',
        // 'entities.wikipediaPage.data',
        /* FETCHER PERSISTEDCACHE ADMIN MODULES */
        'fetcherAdminSchemas',
        'fetcherAdminLog',
        /* FETCHER PERSISTEDCACHE ORM */
        'entities.tag.data',

        /* SPAWNER PERSISTEDCACHE ADMIN ORM */
        'entities.repository.data',
        'entities.domaintld.data',
        'entities.template.data',
        'entities.domain.data',
        'entities.deployment.data',
        /* SPAWNER PERSISTEDCACHE ADMIN MODULES */
        'spawnerAdminSchemas',
        // 'spawnerAdminLog',
        /* SPAWNER PERSISTEDCACHE ORM */
        'entities.site.data',
        'entities.server.data',

        /* CRAWLER PERSISTEDCACHE ADMIN ORM */
        /* CRAWLER PERSISTEDCACHE ADMIN MODULES */
        /* CRAWLER PERSISTEDCACHE ORM */

        /* MONITOR PERSISTEDCACHE ADMIN ORM */
        /* MONITOR PERSISTEDCACHE ADMIN MODULES */
        /* MONITOR PERSISTEDCACHE ORM */


        /* modules */
        'filter',
        'keys',
        'site',
        'schemas',
      ],
    }),
  ],

  state,
  mutations,
  actions,
  getters,

  modules: {
    /* FETCHER MODULES */
    fetcherAdmin,
    fetcherAdminLog,
    fetcherAdminSchemas,
    fetcherAdminChannel,
    fetcherAdminCommonString,
    fetcherAdminFeed,
    fetcherAdminFeedRule,
    fetcherAdminJob,
    fetcherAdminJobItem,
    fetcherAdminList,
    fetcherAdminListItem,
    fetcherAdminNetwork,
    fetcherAdminPost,
    fetcherAdminProfile,
    fetcherAdminTag,
    fetcherPost,
    fetcherTag,

    /* SPAWNER MODULES */
    spawnerAdmin,
    spawnerAdminSchemas,

    /* CRAWLER MODULES */
    /* MONITOR MODULES */

    schemas,
    site,
    debug,
    layout,
    filter,
    keys,
    meta,
    lang,
  },
});

export default store;
